export function Logo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Group_6"
      data-name="Group 6"
      xmlns="http://www.w3.org/2000/svg"
      width="142.101"
      height="124.067"
      viewBox="0 0 142.101 124.067"
      {...props}
    >
      <g id="Group_5" data-name="Group 5">
        <g id="Group_3" data-name="Group 3">
          <path
            id="Path_2"
            data-name="Path 2"
            d="M123.261,66.905c-.752,1.367-2.192,3.477-4.025,3.818-1.621.3-.352-2.649-.065-3.2.735-1.4,2.154-3.36,3.939-3.794,1.747-.424.424,2.631.151,3.174m1.89-12.694c-.053,0-.1,0-.153,0a1.45,1.45,0,0,0-.158-.014c-2.957-.105-5.835,1.224-8.191,2.728a33.219,33.219,0,0,0-8.184,7.593,34.761,34.761,0,0,0-5.737,10.4c-.935,2.823-1.479,6-.576,8.885a6.219,6.219,0,0,0,4.836,4.344c2.855.54,5.835-.593,8.226-1.923,6.75-3.76,11.91-10.485,14.509-17.141,1.792-4.588,3.493-14.337-4.571-14.872"
            transform="translate(9.368 -19.551)"
            fill="#fff"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M84.539,60.48c-1.885.674-1.006-3.278-.779-4.021.576-1.894,1.854-4.63,3.909-5.5,2.009-.854,1.089,3.239.879,3.975-.6,1.861-1.874,4.785-4.009,5.549m12.7-11.4c-.391-5.53-2.6-11.042-9.2-10.507a1.6,1.6,0,0,0-.187.026,1.5,1.5,0,0,0-.192.01c-3.586.408-6.758,2.607-9.263,4.933A40.027,40.027,0,0,0,70.2,54.616a44,44,0,0,0-4.622,14.165c-.506,3.732-.46,7.84,1.26,11.313a7.956,7.956,0,0,0,6.776,4.594c3.559.16,6.9-1.81,9.483-3.924a35.036,35.036,0,0,0,6.044-6.442c2.921-14.213,6.825-22.721,8.089-25.237"
            transform="translate(-4.524 -25.525)"
            fill="#fff"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M116.653,125.191c-3.652-.919-3.906-4.927-1.969-10.594.865.506,1.625.984,2.254,1.426,4.807,3.378,3.008,9.994-.285,9.168M68.679,135.674c-1.66,4.389-6.677,3.218-5.466-1.595.553-2.2,3.808-5.762,8.421-9.894a52.677,52.677,0,0,1-2.954,11.488m84.992-81.642c-5.316-2.145-12.57-.993-20.524,7.774-6.1,6.725-11.4,20.257-17.054,31.958-5.73-7.578,12.942-40.447,12.942-40.447a13.933,13.933,0,0,1-12.985.468s-1.509,3.286-3.206,8.076l-1.322,3.946c-3.521,11.224-6.409,26.91,2.892,31.488-1.68,3.6-3.206,7.08-4.465,10.289l-7.481-4.857,8.168-5.944-9.652,5.122L91.359,95.76l7.958,7.03-15.371,8.154c.735-3.973,3.138-15.121,3.655-19.65-3.039-.777-4.7-2.659-6.668-5.578-2.063-3.061-4.549-11.6,1.778-26.516a43.466,43.466,0,0,1,9.789-14c3.956-3.887,7.743-6,11.583-6.463.079-.01.162-.017.247-.019s.159-.022.239-.03c4.266-.547,8.882,2.046,9.873,4.778-8.863-24.43-57.315-24.676-44.725,55.814.388,2.482.8,4.651,1.176,6.677-23.051,2.588-11.813-59.74-11.813-59.74s-34.72-.492-37.609,21.99C19.4,84.273,38.793,86.7,38.793,86.7s-13.779-3.463-8.419-12.722c2.835-4.9,7.3-5.7,13.573-5.027,0,0-8.325,42.049,20.9,45.185a25.7,25.7,0,0,0,7.268-.779c.152,1.267.239,2.024.3,3.389l-3.465,2.53s-13.46,8.234-15.968,18.212C50.5,147.339,60,154.713,68.736,149.02c4.9-3.192,9.964-13.646,13.906-31.683,5.74-4.465,13.114-9.66,18.239-13.055h0l7.527,7.478a71.174,71.174,0,0,0-1.98,7.945s-2.251,10.8,7.152,13.161c4.807,1.208,10.117-2.169,11.531-7.79.03-.119,2.645-7.006-8.13-14.036,0,0,9.418-11.907,13.177-16.236-1.292-2.922-2.67-16.93,13.974-30.026a26.285,26.285,0,0,1,7.187-3.634c5.925-1.712,11.23,1.607,12.1,4.43a15.174,15.174,0,0,0-9.747-11.542"
            transform="translate(-21.316 -29.122)"
            fill="#fff"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M70.81,115.16l1.472.228c1.43.221,2.226-.235,2.406-1.4.162-1.047-.5-1.657-2.067-1.9l-1.3-.2ZM70.1,119.7l1.387.217c1.954.3,2.791-.148,2.979-1.351.184-1.188-.52-1.893-2.274-2.165l-1.543-.239Zm-1.4.913,1.556-10.023,2.618.406c2.321.361,3.313,1.443,3.05,3.141a2.15,2.15,0,0,1-1.883,1.868l-.006.028a2.441,2.441,0,0,1,1.691,2.743c-.294,1.9-1.661,2.671-4.365,2.251Z"
            transform="translate(-3.226 1.982)"
            fill="#fff"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M80.1,118l3.981-.1-1.365-3.119c-.287-.652-.529-1.22-.743-1.759h-.028c-.174.549-.39,1.126-.645,1.792Zm2.395-6.519,4.552,9.992-.041.044-1.332.032-1.137-2.594-4.84.115-1,2.646-1.332.032-.044-.043,4.1-10.2Z"
            transform="translate(0.065 2.321)"
            fill="#fff"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M88.641,111.968l.749,3.4,1.371-.3c1.693-.373,2.187-1.054,1.941-2.174-.268-1.216-1.053-1.586-2.69-1.226Zm7.88,7.27-.048.246-1.26.276-3.988-3.653-1.595.351.952,4.324-1.216.268-2.183-9.9,2.869-.631c2.1-.463,3.493.213,3.912,2.115a2.516,2.516,0,0,1-1.5,2.985Z"
            transform="translate(3.83 1.898)"
            fill="#fff"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M100.163,116.871l1.278-.582c1.8-.819,2.254-1.655,1.748-2.762s-1.472-1.3-3.088-.561l-1.42.645Zm-1.9-4.185,1.356-.616c1.317-.6,1.731-1.418,1.245-2.487-.439-.964-1.325-1.112-2.773-.453l-1.2.546Zm1.234,5.719-4.2-9.23,2.413-1.1c2.138-.973,3.561-.614,4.274.951a2.152,2.152,0,0,1-.55,2.595l.011.026a2.44,2.44,0,0,1,2.918,1.362c.8,1.748.077,3.145-2.413,4.278Z"
            transform="translate(6.924 0.815)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_9"
          data-name="Path 9"
          d="M106.973,109.507l2.085,2.789,3.808-2.848.571,1-4.692,3.507-6.071-8.122,4.692-3.508.8.832-3.809,2.846,1.93,2.582,3.522-2.633.687.918Z"
          transform="translate(9.744 -1.173)"
          fill="#fff"
        />
        <g
          id="Group_4"
          data-name="Group 4"
          transform="translate(120.96 84.271)"
        >
          <path
            id="Path_10"
            data-name="Path 10"
            d="M110.518,100.5l2.592,2.324.937-1.045c1.158-1.291,1.162-2.133.308-2.9-.929-.83-1.781-.673-2.9.575Zm10.641,1.307.1.227-.861.96-5.371-.64-1.089,1.216,3.3,2.954-.832.927-7.55-6.769,1.959-2.186c1.433-1.6,2.961-1.865,4.412-.565a2.519,2.519,0,0,1,.525,3.3Z"
            transform="translate(-108.856 -87.438)"
            fill="#fff"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M121.672,100.12l-.963-.875.033-.047a5.151,5.151,0,0,0,2.595-1.794,1.807,1.807,0,0,0-.287-2.634c-.7-.481-1.426-.481-3.084.584-1.915,1.237-3.065,1.313-4.161.557-1.168-.806-1.455-2.381-.356-3.971a5.152,5.152,0,0,1,2.187-1.832l.948.846L118.55,91a4.31,4.31,0,0,0-2.219,1.6,1.48,1.48,0,0,0,.206,2.2c.649.448,1.23.361,2.92-.649,2.169-1.3,3.22-1.257,4.3-.508,1.307.9,1.659,2.712.479,4.422a5.951,5.951,0,0,1-2.567,2.056"
            transform="translate(-106.602 -90.109)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
